import { Box, Flex, Text, Button, HStack } from "@chakra-ui/react"
import { FaRedo } from "react-icons/fa"
import { Toaster } from "@hydrologiq/shared/chakra/Toaster"
import { refreshApp } from "../../hooks/useVersionCheck"
import { CloseButton } from "@hydrologiq/shared/chakra/CloseButton"

interface VersionToastProps {
  hasNewVersion: boolean
  onDismiss: () => void
  /** True when the user has dismissed this notification before */
  previouslyDismissed?: boolean
}

export const VersionToast = ({ hasNewVersion, onDismiss, previouslyDismissed = false }: VersionToastProps) => {
  if (!hasNewVersion) return null

  const bg = previouslyDismissed ? "grey" : "#39aed2"

  return (
    <Box
      position="fixed"
      bottom={4}
      right={4}
      zIndex="toast"
      bg={bg}
      color="white"
      borderRadius="lg"
      shadow="lg"
      p={3}
      pt={1}
      maxW="340px"
      w="full"
    >



          <Flex align="center" justify="space-between" mb={1}>
            <HStack><Box
              bg="whiteAlpha.200"
              borderRadius="full"
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexShrink={0}
              mt={0.5}
            >
              <FaRedo size={12} />
            </Box>
              <Text fontWeight="semibold" fontSize="sm" lineHeight="short">
                New version available
              </Text>
            </HStack>
            <Box>
            <CloseButton
            size={"sm"}
            pr={3}
              onClick={onDismiss}
              aria-label="Dismiss update notification"
            /></Box>
          </Flex>
          <HStack><Text fontSize="xs">
            Refresh to get the latest features
          </Text>
            <Button
              variant={"hydrologiq_secondary"}
              onClick={() => refreshApp()}
            >
              Refresh now
            </Button>
          </HStack>
    </Box>
  )
}

export const VersionToastContainer = () => {
  return <Toaster />
}
